export default {
  bank_product: {
    complete_msg:
      '<span>商品の登録</span>いただき心から感謝し、より良い商品で応えます。',
  },
  enter_amount: '金額を入力してください。',
  reg_complete: '登録完了',
  subscription_details: '登録内容',
  select_withdrawal_account: '出金口座を選択',
  email_address: 'メールアドレス',
  product_info: '商品情報',
  new_amount: '新規金額',
  min_running_amount: '最小実行額 ',
  max_running_amount: '最大実行額 ',
  product_type: '商品の種類',
  bank_product_name: '商品名',
  reg_start_date: '登録開始日',
  reg_end_date: '登録終了日',
  exec_start_date: '実行開始日 ',
  exec_end_date: '実行終了日 ',
  basic_info: '基本情報',
  not_applicable: '該当なし',
  subscription: '加入する',
  service_prepare: 'サービス準備中です。',
  no_buy_list: '購入履歴がありません。',
  no_sell_list: '販売履歴はありません。',
  no_list: 'リストはありません。',
  locale_name: '日本語',
  Sale_registration: '販売登録',
  apply: '申請',
  status: '状態',
  wallet: 'ウォレット',
  wallet_address: '財布アドレス',
  wallet_transfer: '外部送金',
  buy: '購入',
  sell: '販売',
  all: '全体',
  breakdown: '内訳',
  act_buy: '買う',
  act_sell: '売る',
  asset: '資産',
  select: '選択',
  no_select: '選択なし',
  account: '口座',
  balance: 'バランス',
  login: 'ログイン',
  logout: 'ログアウト',
  register: '会員登録',
  select_cancel: 'オフ',
  cancel: 'キャンセル',
  modify: '修正',
  auto_input: '(自動入力)',
  confirm: '確定',
  look_up: '照会',
  password: 'パスワード',
  account_delete: '脱退',
  detail: '詳細',
  list_detail: '詳細詳細',
  birth: '誕生日',
  welcome: '歓迎します。',
  please_login: 'ログインしてください。',
  confirmation_login: 'ログイン時に確認できます。',
  id: 'ID',
  find_id: 'ID検索',
  find_password: 'パスワードを忘れた',
  back: '戻る',
  agreement: '規約に同意',
  info_input: '情報の入力',
  success: '完了',
  agree_msg: '同意します。',
  all_agree: '私はすべてに同意します',
  agree: '同意',
  agreed: '同意しました',
  confirm_password: 'パスワードの確認',
  repeat_password: 'パスワードを認証する',
  next: '次へ',
  before: '戻る',
  register_success: '会員登録されている。',
  verify: '確認',
  retention: '保有',
  allow: '(許可)',
  disallow: '(非許可)',
  upload_btn: 'ここにファイルをドロップしたり、クリックしてください。',
  continue_entry: '続行するには  "[+:verification]" の下に入力してください。',
  login_msg_1: 'コイン関連のアカウントを でご活用ください ！',
  login_msg_2:
    '私たち@:(brand.name)を通じて取引や財布やサービスを ご利用ください。',
  login_msg_3: '@:(brand.name)は、すべての環境をサポートしています。',
  brand_register: '@:(brand.name)会員登録',
  register_msg_1: 'メンバーとして参加。 <br />利用規約に同意してください',
  register_msg_3:
    '@:(brand.name)アカウントは、使いやすさで、すべてのサービスへのアクセスを提供します。',
  register_msg_all:
    'すべての動きは必須と選択項目の合意も含まれており、個別に同意を選択することができます。選択項目の同意を拒否される場合もサービスは利用可能です。',
  register_title: '私は19歳以上の年齢より上です。',
  register_title_2: '@:(brand.name)規約',
  register_title_3: '@:(brand.name)統合サービス規約',
  register_title_4: '@:(brand.name)マーケティング活用同意',
  register_title_5: '個人情報の収集と利用に同意',
  register_title_6: '位置情報の収集と利用に同意',
  register_title_7: 'プロファイル情報を追加収集に同意',
  register_title_8: '入力@:(brand.name)アカウント情報',
  register_title_9: '入力された情報',
  register_msg_4:
    '本規約は、会社が提供するすべてのサービスなど、共通に適用され、<br />本規約に同意することにより、そのサービスを別途利用契約を締結せずに利用することができます。',
  required: '[必須]',
  option: '[選択的]',
  otp_notice: 'OTPを有効および無効にできない状態です。',
  required_check: '必須項目にすべてチェックしてください',
  check_input: '内容をすべて入力してください。',
  register_guide: '使い方@:(brand.name)へ',
  register_step1: '@:(brand.name)ボタンをクリックします',
  register_step2: '@:(brand.name)支払うためにログイン',
  register_step3: 'ペイ/リチャージ@:(brand.name)ログイン',
  copy: 'コピーする',
  no_account: '登録された口座がありません。',
  inviter_link: 'オススメリンク',
  register_used_account: '頻繁に使用するアカウントの登録',
  security_certification: 'セキュリティ認証',
  admin_security: '{action}様のセキュリティ等級は、{limit}です。',
  company: '企業',
  exact_calculation: '精算',
  profile: '会員情報',
  inquiry: 'お問い合わせ',
  announcement: 'お知らせ',
  information: '情報',
  history: '内訳',
  registration_date: '登録日',
  pay: '支払い',
  detail_search: '詳細検索',
  more_view: '詳しく見る',
  exchange_store: '取引所',
  external_exchange_store: '外部取引所',
  internal_exchange_store: '内部取引所',
  external_transaction: '外部取引',
  internal_transaction: '内部取引',
  favorites: 'お気に入り',
  no_favorite_list: 'お気に入り内訳はありません。',
  no_alias: '終結',
  please_enter_account_name: '口座名を入力してください。',
  variable_amount: '変動額',
  changes: '変動内訳',
  account_transaction_history_inquiry: '取引明細照会',
  exchange_application_completed: '両替申し込み完了しました。',
  choose_how_pay_fee: '手数料の支払い方法を選択',
  free: '無料',
  closing: '終結',
  relative_asset_inquiry: '相手の資産照会',
  please_enter_relative_account_number: '相手の口座番号を入力してください。',
  Please_enter_relative_wallet_address:
    '相手の財布アドレスを入力してください。',
  memo: 'メモ',
  write_history_memo: '内訳メモを取っばご管理するのに便利です。',
  re_enter: '再入力',
  transfer_wallet_account: '変形財布アドレス',
  transfer_wallet_inquiry: '変形財布照会',
  Kiosk: '売店',
  withdrawable_amount: '出金可能額',
  transferred_assets: '変形資産',
  recipient: '受ける方',
  recipient_wallet: '受ける方の財布',
  register_user_name_tit:
    'セキュリティ認証のための実名で記入することをお勧めします。',
  register_password_tit:
    '頻繁に使用するメールアドレスを正確にご記入してください。',
  product_name: '商品名',
  dividend_type: '配当型',
  auto: '自動',
  manual: '手動',
  s_usdt_protocol: 'テザープロトコルの選択',
  ccf: {
    what_ccf: 'USOTとは?',
    key_coin: '暗号通貨を実際の通貨で繋ぐ@:(brand.name)のコイン',
    ccf_description:
      '多様な暗号貨幣をダイレクト両替とC2C取引を通じて換算した@:(brand.name)だけの基軸コインであり,1USOTはUSD 1CENTの価値を持ちます。 USOTは@:(brand.name)でよりはやくて安全な購買と取引を可能にします.',
    how_use_ccf: 'USOTはどう使うの?',
    brand_wallet_transfer:
      '外部取引所に保管された暗号貨幣資産を@:(brand.name)の財布で振り込みします.',
    ccf_conversion:
      '財布で振り込みされた暗号貨幣をダイレクト両替またはC2C取引を通じてUSOTで転換します.',
    direct_exchange_c2c_deal: 'ダイレクト両替C2C取引',
    ccf_moved: '転換されたUSOTは@:(brand.name)口座に移されます.',
    how_use_account_ccf: '口座に移されたUSOTはこのように使います!',
    freely_purchase_open_market:
      'USOTでOPEN MARKETの商品を自由に購入してみてください!',
    free_deposit_withdrawal: 'BANK内口座間の自由な入出金と振り込みが可能です!',
    exchange_currencies_convenient:
      'ダイレクト両替とC2C取引を通じて貨幣間の交換が便利になります!',
    offline_convenient:
      'オフラインでも@:(brand.name)のサービスを一層便利に利用してください!',
    how_wallets_accounts_different: '財布と口座はどう違うのでしょうか?',
    same_means_storing_cryptocurrency:
      '@:(brand.name)で財布と口座は暗号貨幣を保管する等しい手段だが暗号貨幣の取引形態(内外部)によってその使いが違います。 すなわち、取引所と@:(brand.name)間の取引(外部)では財布が使われて、@:(brand.name)中での取引(内部)では口座が使われる形態です.',
  },
  header: {
    certification_management: '認証/管理',
    c2c_enroll: '購入/販売登録',
    wallet_list: '財布/内訳照会',
    wallet: '財布',
    c2c_list: '購入/販売履歴',
    no_c2c_sell_list: '販売履歴はありません。',
    transfer_list: '両替内訳',
    no_transfer_list: '両替内訳はありません。',
    withdrawal_list: '口/出金内訳」',
    my_info: '私の情報',
    home: 'メイン',
    payment_history: '支払い履歴',
    account_transfer: '口座振替',
    transfer_history: '振り込み内訳',
    register_used_account: '頻繁に使用するアカウントの登録',
    exchange: '両替する',
    exchange_list: '両替内訳',
    email: 'メール',
    email_list: 'メールの履歴',
    otp: 'OTP',
    otp_list: 'OTP内訳',
    register_account: '口座を登録する',
    calculation_account_list: '精算口座リスト',
    security_certification: 'セキュリティ認証',
    exact_calculation: '精算',
    history: '内訳',
    information: '情報',
    my_profile: '私の情報',
    email_modify: 'メールの変更',
    password_modify: 'パスワードの変更',
    inquiry: 'お問い合わせ',
    inquiry_history: 'お問い合わせ内訳',
    one_on_one_inquiry: '1:1 お問い合わせ',
    frequently_asked_questions: 'FAQ',
    announcement: 'お知らせ',
    notice: 'お知らせ',
    server_notice: 'サーバーお知らせ',
    service_center: 'サービスセンター',
    profile: '会員情報',
    company: '企業',
    account_management: '口座管理',
    do_exchange: '両替する',
    transfer: '振り込み',
    look_up: '照会',
    faq: 'FAQ',
    server: 'サーバー',
    email_request: 'メールお問い合わせ',
    Product_Subscription: '商品＆加入',
    easy_payment: '簡単決済',
    easy_login: '簡単ログイン',
  },
  footer: {
    footer_msg: 'コイン関連のアカウントを@:(brand.name)でご活用ください！',
    footer_sub_msg:
      '私たち@:(brand.name)を通じて取引や財布とサービスをご利用ください',
    footer_sub_msg2: 'Tip',
    footer_sub_msg3: '@:(brand.name)は、すべての環境をサポートしています。',
    ICO: 'ICO',
    c2c: 'P2P取引所',
    b2c: 'B2C取引所',
    margin_exchange: 'バイナリ取引所',
    gift_exchange: '先物取引所',
    Binary: 'バイナリオプション',
    integrated_exchange: '統合取引所',
    open_marcket: 'オープンマーケット',
    game: 'ゲーム」',
    proceed: '進行中の取引',
    public: '上場ニュース',
    direct_ex: 'ダイレクト両替',
    buy: '購入する',
    sell: '販売する',
    buy_sell: '購入/販売',
    holding_coin: '保有コイン',
    fee: '手数料のご案内',
    exchange: '取引所',
    transfer_record: '取引記録',
    Leverage: 'レバレッジ',
    live_exchange: 'ライブ取引',
    demo_exchange: 'デモ取引',
    contest: '大会',
    powerball: 'パワーボール',
    law:
      '法律：@.upper:(brand.domain)は登録番号：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（オーストラリア）の全所有者である@:(brand.legalName)の登録番号：70638826927商号名です。',
    law2:
      'このウェブサイトは、@:(brand.legalName)によって運営されます。 @:(brand.legalName)は承認番号64190  -  Auxiliary finance serviceの規制を受けており、参考番号70638826927、オーストラリアに登録されています。',
    law3:
      '@:(brand.name)はオーストラリアの金融商品の投資ガイドラインに従って動作します。',
    law4:
      'ref。 no。 538324 | ABN reg。 70638826927 | BA reg。 64190.居住国の法律の規定に@:(brand.name)サービスの利用が許可されていることを確認することは完全にお客様の責任です。',
    law5: '@:(brand.name)のリスク開示全文をお読みください。',
    law6:
      '@:(brand.name)は、米国、ベリーズ、モーリシャス、日本、アルバータ州、ブリティッシュコロンビア州、ケベック州、サスカチュワン、ハイチ、スリナム、北朝鮮、プエルトリコ、およびキプロス占領地域の住民にサービスを提供していません。',
    law7:
      '詳細については、よくある質問の規制部分を参照してください。当社のリスク開示を参考にしてください。',
    law8:
      '制限地域：Trading Point of Financial Instruments Ltdは、第三世界の国と地域への投資と付随サービスを提供していません。',
    law_warn: '危険告知：',
    law_1:
      'CFDは複雑な商品であり、レバレッジにより迅速にお金を失う危険性が高くなります。個人投資家の口座のうち69.10％がCFDを取引する際にお金を失った。',
    law_2:
      'あなたはCFDの動作を理解しているかどうかは、お金を失う危険性が高いという点を甘受することができるかについて考慮する必要があります。当社のリスク開示を参考にしてください。',
    alert_title: '参考にと注意事項',
    market: '@:(brand.group)マーケット',
    ieo_market: 'IEOマーケット',
    news: 'News',
    event: 'イベント',
    platform_rental_title: 'プラットフォーム賃貸',
    education: '教育',
    online_Academy: 'オンラインアカデミー',
    offline_Academy: 'オフラインアカデミー',
    shopping_basket: 'カート',
    best_product: 'Best商品',
    order: '注文',
    my_page_title: 'マイページ',
    member_info_management: '会員情報の管理',
    order_management: '注文管理',
    my_question: '私の質問',
    one_enquiry: '1：1お問い合わせ',
    community: 'コミュニティ',
    lotto: '宝くじ',
    rock_event: 'Rock Event',
    quiz_game: 'クイズゲーム',
    ladder_game: 'はしごに乗る',
    tetris: 'テトリス',
    split_lotto: '分割ロト',
    day_Lottery: '一日宝くじ',
    attendance: '出席チェック',
    scoop_out: '埋め込み',
    forum: 'フォーラム',
  },
  main_msg: {
    about_1_title: '世界最高のパスワード貨幣取引サービス',
    about_1_msg: 'コインのすべてのサービスを@:(brand.name)がリードします。',
    about_1_1_msg:
      '全世界で初めて、パスワード貨幣コインをしたところで購入販売が可能です。',
    about_1_2_msg: 'ダイレクト両替に関しては@:(brand.name)で利用可能です。',
    about_2_title: 'すぐに両替システム',
    about_2_msg:
      '@:(brand.name)は安定した、複数の平行マッチング技術を利用して すぐに両替ができるように高度化された設計技術を適用した 両替システムを保有しています。',
    about_3_title: '財布作成',
    about_3_msg:
      '@:(brand.name)は国内最高の技術陣で構成されたセキュリティの専門家が 最先端のセキュリティシステムを備えてWALLETシステムを提供しています。',
    about_4_title: '簡単に取引システム（C2C）',
    about_4_msg:
      '@:(brand.name)は、ユーザーフレンドリーな簡単取引システムを構築して より便利な取引を行うことができるようにしましょう。ㄴ',
    c2c_main_msg1_1:
      '@:(brand.name)は安定マルチ平行マッチング技術を利用して、すぐに両替が',
    c2c_main_msg1_2:
      '可能なように高度化された設計技術を適用した両替システムを保有して',
    c2c_main_msg1_3: 'ています。',
    c2c_main_msg2_1:
      '@:(brand.name)は国内最高の技術陣で構成されたセキュリティの専門家が',
    c2c_main_msg2_2:
      '最先端のセキュリティシステムを備えてWalletシステムを提供しています。',
    c2c_main_msg3_1:
      '@:(brand.name)はユーザーフレンドリーな簡単取引システムを構築しても',
    c2c_main_msg3_2: '便利な取引を行うことができます。',
  },
  toasted_msg: {
    agree_required_term: '必須の条件に同意してください',
    must_read_term: '約款を最後まで読むかダウンロードする必要かあります。',
    confirm: '確認されて',
    changed: '変更されました',
    withdrawal: '脱退しました',
    register: '登録されている。',
    delete: '削除された。',
    title: '通知',
    exchange: 'ダイレクト両替が正常に処理されました。',
    search: '照会しました。.',
    deposit_request: '入金の申請されました。',
    withdraw_request: '出金の申請されました',
    create_account: '開設されました.',
    modify: '修正されました。.',
    cancel: 'キャンセルされました。',
    trade_confirm: '取引確定されました。',
    trade_reject: '取引拒否されました。',
    copy: 'コピーされました。',
    nice_msg:
      'ブラウザの設定でポップアップが許可されていない場合は、本人認証が正常に行われていません。',
    nice_title: '案内',
    nice_success: '本人認証が正常に処理されました。',
    nice_error: '本人認証を行うことができません。',
    no_transfer: '両替情報がありません。',
    email_auth: 'Eメール認証が正常に完了しました。',
    email_auth_send: '認証メールが送信されました。',
    kyc_withdraw: '口座認証に成功しました。',
    not_allow_trade: '取引無効状態です。',
    id_find_mail_send: 'IDがメールで送信されました。',
    duplicate_check: '重複IDまたはメール。',
    pay: '支払い完了しました。',
  },
  private: {
    deal_list: '販売履歴',
    app_list: '購入履歴',
    deal_buy_asset: '購入する資産',
    buy_price: '購入価格',
    confirmed_source_amount: '確定販売数量',
    holding_source_amount: '未確定販売数量',
    potential_source_amount: '利用可能数量',
    direct_market: 'ダイレクト両替',
    deal_enroll: '販売登録',
    app_enroll: '購入登録',
    select_market: 'マーケットの選択',
    fee_rate: '手数料',
    deal_info_input: '販売情報入力」',
    deal_source_amount: '販売数量',
    deal_price: '本あたり販売価格',
    deal_enroll_account: '販売登録用口座',
    account_select: '口座選択',
    direct_asset_select: '販売及び購買する資産を選択してください。',
    please_select_asset: '資産を選択してください。',
    basic_rate: '現相場',
    direct_transfer_buy: 'すぐに購入時',
    direct_transfer_sell: 'すぐに販売時',
    direct_source_amount: '両替数量',
    direct_target_amount: '適用量',
    direct_asset_buy: '{0}で購入',
    direct_asset_sell: '{0}で販売',
    selected_deal_info: '選択された販売情報',
    deal_source_asset_title: '購入資産',
    deal_total_source_amount: '総販売数量',
    app_info_input: '購入情報入力',
    app_amount: '購入数量',
    app_deal_price: '単価',
    pay_target_amount: 'お支払いすべき数量',
    fee: '手数料',
    fee_calc: '手数料額',
    msg_fee_calc: '{0}だけ差し引かれます。',
    app_account: '購入登録用口座',
    app_receive_account: '受ける口座を選択',
    c2c_buy_select_asset: '購入資産を選択してください',
    go_home: 'メインページに戻る',
    buy_calc_spread: '購買為替レート',
    sell_calc_spread: '販売為替レート',
    cs_market_asset: '資産の組',
    cs_market_basic_rate: 'マーケティング基準率',
    transfer_type: '両替タイプ',
    exchange_rate: '適用為替レート',
    submit_transfer: 'すぐに両替',
    deal_source_min_amount: '最小購入数量',
    closed_date: '終結こと',
    no_deal: '販売リストなし',
    app_price_per_quantity: '数量あたりの価格',
    app_fee_amount: '手数料合計',
    select_deal_app_list: '選択された販売の購入履歴',
    no_select_deal_app_list: 'その販売に購入履歴なし',
    transfer_source_amount: '基準資産数量',
    transfer_target_amount: '相手の資産数量',
    transfer_basic_rate: '適用マーケティング基準率',
    transfer_spread_rate: '適用スプレッド率',
    transfer_exchange_rate: '適用為替レート',
    transfer_list_detail: '両替申込内訳の詳細',
    transfer_source_asset: '基準資産',
    transfer_target_asset: '相手の資産',
    transfer_source_account_number: '基準資産口座番号',
    transfer_target_account_number: '相手の資産口座番号',
    transfer_detail_type: '交換タイプ',
    transfer_regdate: 'アプリケーションこと',
    transfer_asset_info: '{0}を{1}に{2}',
    transfer_asset_select: '交換する資産を選択してください。',
    msg_transfer_buy: '{0}で購入',
    msg_transfer_sell: '{0}で販売',
    deal_fee_amount: '売り公示者課す手数料',
  },
  wallet_page: {
    have_asset: '保有資産',
    asset_list: '資産のリスト',
    account_list: '口座リスト',
    account_create: '口座作成',
    deposit: '入金',
    withdraw: '出金',
    deposit_list_look: '入金内訳照会',
    deposit_look: '入金照会',
    withdraw_list_look: '出金内訳照会',
    withdraw_look: '出金照会',
    account_modify: '口座の変更',
    deposit_apply: '入金申請',
    withdraw_apply: '出金申請',
    deposit_request_amount: '入金金額',
    withdraw_request_amount: '出金金額',
    withdraw_account_info: '出金口座情報',
    holder_name: '預金人',
    bank_name: '銀行名',
    withdraw_bank_address: '口座番号',
    withdraw_address: '資産アドレス',
    qr_address: '口座住所',
    create_qr_address: '口座アドレス開設',
    account_enroll: '口座登録',
    account_seq: '口座固有番号',
    account_title: '口座名',
    regdate: '開設',
    before_regdate: '(開設前)',
    holding_balance: '停止金額」',
    select_asset: '選択資産',
    create: '開設',
    deposit_list: '入金内訳',
    no_deposit_list: '入金の申請内容がありません。',
    deposit_apply_detail: '入金の申請内訳の詳細',
    asset_title: '資産名',
    request_amount: '要求金額',
    withdraw_list: '出金内訳',
    no_withdraw_list: '出金の申請内容がありません。',
    withdraw_apply_detail: '出金の申請内容の詳細',
    withdraw_fee_total_amount: '総送金額(手数料込み)',
    net_amount: '最終的な金額',
    fee_type: '手数料の種類',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: '口座アドレス開設',
    deposit_msg: '外部財布から私の{0}の財布に{0}を堆積します。',
    deposit_msg_1:
      'ブロックチェーンで350回の承認（コンフォーム）を受けた後、{0}取引財布に反映されます。',
    deposit_step_1: 'STEP 1. {0}メモIDを先に確認してください。',
    deposit_step_1_1: '私{0}メモID',
    deposit_step_1_2:
      '{0}入金時、お客様の固有のメモIDを必ず表記してください。メモIDなしで送金された{0}は失われます。',
    deposit_step_1_3: '確認しました。私{0}財布アドレスを表示します。',
    deposit_step_1_btn: 'メモIDのコピー',
    deposit_step_2: 'STEP 2.私の財布アドレスをご確認ください。',
    deposit_step_2_1: 'QRコード',
    deposit_step_2_2: '財布アドレス',
    deposit_step_2_3:
      '最低入金額は<span style = "color：＃4a90e2"> {0} {1} </ span>です。',
    deposit_step_2_btn: '財布アドレスをコピー',
    deposit_msg_2: 'ご確認ください',
    deposit_msg_2_1: '上記アドレスは、入金専用アドレスです。',
    deposit_msg_2_2:
      'コンフォーム完了に要する合計時間は、ブロックチェーンネットワークの混雑度に応じて影響を受けることができ、パスワード貨幣星ブロックチェーン取り込みは<span style = "color：#4a90e2; cursor：pointer;">ここ</span>で確認することができます。',
    no_account_list: '口座のリストがありません。',
    no_favorite_account_list: 'お気に入り口座のリストがありません。',
    input_account: '変更するためにアカウント名を入力してください。',
  },
  my_page: {
    my_profile: '私の情報',
    user_unique_num: '会員固有の番号',
    user_name: 'ユーザ名',
    email_address: '電子メール',
    register_regdate: '登録日',
    last_login: '最近のログイン',
    auth_complete: '認証完了',
    not_auth: '米認証',
    expdate: '有効期限',
    act_auth: '認証する',
    realname_auth: '本人認証',
    email_auth: 'メール認証',
    otp_auth: 'OTP認証',
    enroll: '登録する',
    security: 'セキュリティ等級',
    show_security: '等級表示',
    auth_withdraw_address: '出金アドレス認証',
    apply_list: '申請内訳',
    password_modify: 'パスワードの変更',
    email_modify: '電子メールの変更',
    account_block: 'アカウント脱退',
    placeholder_old_password: '既存のパスワードを入力してください',
    placeholder_new_password: '新しいパスワードを入力してください',
    placeholder_confirm: 'もう一度入力してください',
    placeholder_password: 'パスワードを入力してください',
    placeholder_email: '新しい電子メールを入力してください',
    mail_cert_list: 'メールアプリケーションの履歴',
    no_mail_list: 'メールの申請内容がありません。',
    nominee_detail: '被推薦者の内訳',
  },
  kyc: {
    register_account: '口座を登録する',
    kyc_enroll: 'KYC認証申請',
    kyc_enroll_2: 'KYC 住所証明',
    kyc_enroll_3: 'KYC 4段階上方修正の理由',
    auth: '認証',
    auth_code_send: '認証コード発送',
    auth_code: '認証コード',
    msg_auth_code: '認証コードを5分以内に入力してください。',
    type_title: 'ユヒョンミョン',
    withdraw_auth: '出金アドレス認証',
    withdraw_auth_tit:
      '外部出金のための引き出しアドレス認証の手続きです。出金することが先口座や財布ア ドレスを登録してください。',
    select_asset: '資産選択',
    select_bank: '銀行の選択',
    holder_name: '預金人',
    birth: '生年月日6桁',
    address: '受け取り資産アドレス',
    withdraw_list: '出金口座の申請内容',
    bank_name: '銀行名',
    withdraw_info: '出金口座情報',
    withdraw_complete: 'すでに認証が完了した資産です。',
    regdate: '登録日',
    delete_withdraw_address: 'アドレス変更',
    delete_success_address: '出金アドレスが変更されました。',
    kyc_cert_list: 'KYCの申請内容',
    no_kyc_list: 'KYCの申請内容がありません。',
    no_kyc_withdraw_address_list: '出金口座の申請内容がありません。',
    kyc_placeholder: 'を入力してください。',
  },
  otp: {
    enter_verification_number: 'OTP認証番号を入力してください',
    otp_auth: 'OTP認証',
    authenticode: 'OTPキー',
    otp_deactivate: 'OTPを無効に',
    msg_authenticator_installation:
      'Google Authenticator」アプリをスマートフォンやデスクトップに設置してください',
    android: 'アンドロイド ',
    or: 'または ',
    iphone_series: 'iPhone、iPad、そしてiPod',
    windows_phone: ' Windows Phone',
    and: ', そして',
    msg_microsoft_other_systems: 'Microsoft Windows desktopを含む他のシステム',
    msg_key: 'このキーを ',
    msg_use_loss_change:
      ' 紙に書いてください。端末を紛失してしまったり、OTPを変更するときに使用されます。',
    msg_brcode_touch:
      'Google Authenticator」アプリを起動し、画面の下の<b> Scan QR barcode </ b>をタップしてください。',
    msg_input_authenticode:
      '端末の画面に表示された認証コードを下の「認証コード」の欄に入力してください。',
    otp_key: 'OTPキー',
    otp_activate: 'OTPを有効に',
    otp_copy: 'OTPキーがコピーされました。',
    otp_safe_keeping: 'OTPキーを紙に書いた後、安全な場所に保管しましたか?',
    yes: 'はい',
    otp_register: '登録',
    otp_register_success: 'OTP登録が正常に完了しました。',
    otp_delete_success: 'OTP抹消登録が正常に完了しました。',
    msg_click_key_copy: 'クリックすると、キーがコピーされます。',
    otp_login: 'OTPログイン',
  },
  security: {
    show_security: 'セキュリティ等級を表示',
    grade: '評価',
    condition: '条件',
    restriction: '制限事項',
    no_grade: 'ムドゥングプ',
    no: 'なし',
    security_title: 'セキュリティ等級別の条件別の制限事項',
    banner1: '信頼できるセキュリティ',
    banner2:
      '@:(brand.name)を通じた購入または売却のために、@:(brand.name)は、データの暗号化、リアルタイムの取引監視、買い手と売り手の保護政策、@:(brand.name)の安全決済とお支払い受信 方式を使用して、ユーザーとすべての支払いを安全に保護します。',
    banner_invite: '@:(brand.name)アカウントがないですか？',
    banner_join: '無料会員登録',
    banner3: '@:(brand.name)は、顧客の安全保つ方法',
    content1_h3: 'バイヤーの保護',
    content1_text:
      'バイヤーが誤配送やミベソン被害を受ける場合には、@:(brand.name)は適格な取引について送料を含めた全体の決済代金を補償することができます。*',
    content2_h3: '販売保護',
    content2_text:
      '売り手が適格な販売についての不正請求やミベソンクレームを受けた場合には、全体の金額を保護することができます。*',
    content3_h3: 'データの暗号化',
    content3_text:
      'TLS、HTTPS接続、モバイルアプリのキーショットピーニング、PCIコンプライアンスに支払いをより安全に守ってくれます。',
    content3_btn: 'PCIコンプライアンス',
    content4_h3: '詐欺防止',
    content4_text:
      'すべての取引をリアルタイムで監視し、アカウントを分析し、不正行為及び決済を予防するようにサポートします。',
    sec_h2: '購入するかどうかを確認し',
    sec_text:
      '@:(brand.name)は、取引を24時間365日監視するので、いつもと違う何かを検出した場合、購入者に連絡して、本人のログインまたは購入するかどうかを確認するように要求します。また、@:(brand.name)は、電子メールを介してすべての購入と販売を確認します。',
    wran_h2: '疑わしい点を発見した場合',
    warn_step1: '報告。',
    warn_step1_text1: '承認していない取引を発見した場合の内容を確認した後',
    warn_step1_text2: '問題を報告>承認されていない活動届出',
    warn_step1_text3:
      'をクリックするか、すぐに@:(brand.name)にお問い合わせください。',
    warn_step2: '他の問題があることを確認します。',
    warn_step2_text1:
      '最近取引活動とアカウントの設定を確認して、追加請求や変更があることを確認し、この内容も報告して下さい。',
    warn_step3: 'パスワードを変更してください。',
    warn_step3_text1:
      'セキュリティメニューのアカウントの設定で行うことができます。または、アカウントにログインすることができない場合',
    warn_step3_text2: 'ログイン>ログイントラブルシューティング',
    warn_step3_text3: 'をクリックしてリセットしてください。',
    warn_btn: '不正取引申告',
    online_h2: '@:(brand.name)は、安全なオンライン活動をサポートします。',
    online_h3: 'アカウントのセキュリティ',
    online_text: 'セキュリティ性の高いパスワードでアカウントを保護します。',
    online_btn: 'さらに詳しく',
    auth_incomplete: '認証未完了',
  },
  input: {
    id: '入力されたID',
    password: '入力Aのパスワード（特殊文字8-32桁）',
    repeat_password: 'パスワードを認証する',
    user_name: '入力ユーザー名',
    email_address: '入力E-mailアドレス',
  },
  oauth: {
    contact_msg:
      'アプリケーション{0}で、以下の情報にアクセスしようとしています。',
    agree_msg: '{0}で{1}さんの個人情報にアクセスすることに同意しますか？',
    agree_info:
      '提供される情報は、利用者の識別、統計、アカウント連動やCSなどのためにサービス利用期間中に活用/保管されます。基本的な情報と必要な提供の項目は、@:(brand.name)サービスを利用するために、必ず提供されるべき情報です。',
    agree_request: '提供項目',
    agree_msg2:
      '同意後には、そのサービスの利用規約および個人情報の処理方針に基づいて情報が管理されます。',
    agree: '同意する',
  },
  pay_head_foot: {
    account_management: '口座管理',
    settlement_account_list: '精算口座管理',
    account_summary_views: '要約口座照会',
    fund: ' 資金',
    history: '支払い履歴',
    help: 'ヘルプ',
    qa: 'お問い合わせ',
    fee: '手数料',
    secure: 'セキュリティ',
    go_shop: 'ショッピング',
    my_info: '私のプロフィール',
    my_page: 'アカウントの設定',
    out: 'ログアウト',
    in: 'ログイン',
    about: '会社紹介',
    blog: 'ブログ',
    employ: '採用情報',
    site_map: 'サイトマップ',
    developer: '開発者',
    partner: 'パートナー',
    privacy_state: 'プライバシーポリシー',
    usage: '利用規約',
    feed_back: 'フィードバック',
    warn_to_consumer:
      '消費者に通知：@:(brand.name)前払い手段の所有者であるⓒ@:(brand.name)は、オーストラリア金融監督当局の承認を必要としません。利用規約を注意深くお読みください。',
  },
  continue: '続き',
  pay_home: {
    brand_title: '@:(brand.name)',
    platform: 'プラットフォーム',
    platform_rental: 'プラットフォーム賃貸する',
    help: '支援します。',
    home_banner_1: '全世界の潜在的な顧客基盤を広げ、請求管理を容易にし、',
    home_banner_2:
      'ビジネス販売保護*と年中無休詐欺防止監視を介して、安心してお買い物できるようにします。',
    home_banner_3: 'より簡単に成功することができます。',
    home_banner_warn:
      '*販売保護規約が適用されます。利用資格の詳細については、ユーザーの契約を参照してください。',
    home_banner_join: '今すぐ無料で登録してください。',
    home_sec1_openShop: '@:(brand.name)で店を開設することができます。',
    home_sec1_btn: '取引する',
    home_sec2_h2: '希望の方法でのお支払い得る。',
    home_sec2_text1:
      '@:(brand.name)は、オンラインやモバイル、さらには電子メールでも決済することができます。',
    home_sec2_text2:
      'どこで誰に販売ハシドゥン@:(brand.name)がより簡単で安全な支払いを支援します。',
    home_sec2_online_pay: 'オンライン決済',
    home_sec2_online_text:
      '簡単に設定可能な@:(brand.name)の支払いボタンは決済代金と定期決済、寄付などを受ける時も非常に便利です。 @:(brand.name) Checkoutを利用すると、顧客がより簡単かつ迅速に決済することができます。',
    home_sec2_online_more: 'オンライン決済詳しくはこちら',
    home_sec2_voice_invoice: 'メールの請求書',
    home_sec2_voice_text:
      '専門的な無料の請求書に要求する簡単なメール決済。海外のお客様はもちろん、@:(brand.name)アカウントがないお客様にも使用することができます。',
    home_sec2_voice_more: 'メールの請求書についてさらに詳しく',
    home_sec2_exchange_pay: '取引所で決済する',
    home_sec2_exchange_text:
      '取引所で統合財布サービスを利用して、パートナー社どこの取引所でもコインを充電及び購買/販売が利用できます。',
    home_sec2_exchange_more: '取引所の充電さらに詳しく',
    home_sec2_mobile_pay: 'モバイル決済受信',
    home_sec2_mobile_text:
      'ソリューションは、モバイルに自動的に最適化されます。世界中どこでも、モバイルウェブサイトやAndroidおよびiOSアプリを介して、より簡単に決済受けてください。',
    home_sec2_mobile_more: 'モバイル決済詳しくはこちら',
    home_sec3_h2:
      '@:(brand.name)フリーランスのパートナーと一緒に、より多くの仕事を見つけてください。',
    home_sec3_global:
      '@:(brand.name)は、世界最高のフリーランスのサイトと一緒に、より多くのグローバルなチャンスを接続します。',
    home_sec3_btn: 'フリーランスのための@:(brand.name)確認する',
    home_sec4_h2: '簡単に始めることができます。',
    home_sec4_banner1:
      '@:(brand.name)ビジネスハブで開始に必要なすべてのことを知ってみましょう。',
    home_sec4_banner2: 'ビジネスアカウント登録してメールアドレスを確認する',
    home_sec4_banner3: '認証完了し、銀行口座を接続する',
    home_sec4_banner4: '決済ソリューションを選択する',
    home_sec5_h2:
      'なぜ、世界の多くの事業者が<br/>@:(brand.name)を信頼するのでしょうか。',
    home_sec5_sub_text:
      '優れた選択であるからです。 @:(brand.name)は、売り手を世界200以上の市場の2億人以上のお客様に25個の通貨で連結しております。',
    home_sec5_sub_text_1: '優れた選択であるからです。',
    home_sec5_sub_text_2:
      '@:(brand.name)は、売り手を世界200以上の市場の2億人以上のお客様に25個の通貨で連結しております。',
    home_sec5_h3: '安全です。',
    home_sec5_h3_sub1:
      '自動詐欺判別、24時間取引モニタリングと販売者及び購買者を保護するプログラムでビジネスと顧客を安全に保護します。',
    home_sec5_h3_more: 'オンライン決済詳しくはこちら',
    home_sec5_h31: '全世界が使用します。',
    home_sec5_h31_sub1:
      '全世界誰も毎回情報を入力する必要なく、迅速に決済を行うことができます。203個の市場で26個の通貨でクレジットカード、デビットカード又は@:(brand.name)を通じて決済できます。',
    home_sec5_h31_more: 'メールの請求書について',
    home_sec5_h32: '高速です。',
    home_sec5_h32_sub1:
      '顧客が決済すると、ほとんどの場合、すぐに私の@:(brand.name)アカウントに入金されます。銀行で引き出したりベンダーに代金を支払うか、または@:(brand.name)決済が可能なすべての場所で自由に使用してください。',
    home_sec5_h32_more: 'eBay販売詳細を見る',
    home_sec6_h2: '単純な手数料体系',
    home_sec6_sub:
      '@:(brand.name)は販売がされたときのみ手数料を請求します。 @:(brand.name)手数料は販売金額と現在の場所を基準に固定されています。',
    home_sec6_more: '手数料についてさらに詳しく',
    home_sec7_h2: '韓国セラーのためのコミュニティ、CBT LAB',
    home_sec7_text1:
      'クロスボーダー取引の研究所（CBT LAB）は@:(brand.name)コリア（@:(brand.name) Korea）が海外の電子商取引活性化のために後援する販売のコミュニティです。',
    home_sec7_text2:
      'CBT LABは、最新の動向、ヒント、ベストプラクティスなどの情報共有を東海ビジネスが世界的に成長できるように支援しています。',
    home_sec7_more: 'CBT LAB活用方法を学ぶ',
    home_sec8_h2: '@:(brand.name)を連動したパートナーに会ってみてください。',
    home_sec8_text1: 'オンラインビジネスのための専門家の助けが必要ですか？',
    home_sec8_text2:
      'Webホスティングソリューションは、ショッピングカート、Eコマースソリューションなど@:(brand.name)を事前連動したパートナーがお客様のビジネスを支援します。',
    home_sec8_text3:
      '私のビジネスに適した@:(brand.name)のパートナーを今見つけてください。',
    home_sec8_more: 'より多くのパートナーを表示',
    home_sec9_h2:
      'グローバルセラーになってみてください。 @:(brand.name)が付属致します。',
    home_sec9_h2_1: 'グローバルセラーになってみてください。',
    home_sec9_h2_2: '@:(brand.name)が付属致します。',
    home_sec9_btn: '今すぐアカウントを登録する',
    home_learn_h2: 'さらに詳しく',
    home_learn_li1: 'ウェブ決済ソリューション',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: '@:(brand.name) Checkout',
    home_learn_li1_3: 'eBayで販売する',
    home_learn_li1_4: 'ソリューションの比較',
    home_learn_li2: 'その他のお支払い',
    home_learn_li2_1: '@:(brand.name)メールの請求書',
    home_learn_li2_2: 'モバイルコマース',
    home_learn_li2_3: 'ビジネス用の自動支払い',
    home_learn_li2_4: 'B2Bのための@:(brand.name)',
    home_learn_li2_5: 'フリーランスのための@:(brand.name)',
    home_learn_li3: '@:(brand.name)設定と統合',
    home_learn_li3_1: '@:(brand.name)ビジネスハブ',
    home_learn_li3_2: '@:(brand.name)コリア販売コミュニティ（CBT LAB）',
    home_learn_li3_3: 'サイトに@:(brand.name) @:(brand.name)追加する',
    home_learn_li3_4: 'チェックアウトの設定、ベストガイド',
    home_learn_li3_5: '開発者',
    home_learn_li3_6: 'パートナー',
    home_learn_li3_7: '@:(brand.name)使い方',
    home_learn_li4: 'マイアカウントの管理',
    home_learn_li4_1: '@:(brand.name)ビジネスアプリ',
    home_learn_li4_2: 'ビジネスアカウントの設定',
    home_learn_li4_3: '販売保護プログラム',
    home_learn_li4_4: '顧客からの苦情を管理する',
    home_learn_li4_5: '支払い拒否（Chargeback）を理解する',
    home_learn_li4_6: 'アカウントの制限を理解する',
    home_learn_li4_7: '詐欺防止のヒント',
    home_learn_li4_8: 'PCIコンプライアンス',
  },
  pay_nav: {
    view_your_account: '全口座照会',
    account_summary_views: '要約口座照会',
  },
  pay_login: {
    secure_sub_title: 'ログインとセキュリティ',
    secure_my_profile: '私のプロフィール',
    secure_update_complete: 'プロファイルと設定環境が更新されました。',
    secrue_suggest: 'いつでもお客様のご意見を言ってください。',
    search: '検索',
    my_info: '個人情報',
    update: 'アップデート',
    e_mail: 'メール',
    default: 'Basic information',
    call: '電話',
    phone: '（携帯電話）',
    pay_mobile: 'モバイル決済',
    trading: '送受信',
    password: 'パスワード',
    change: '変更',
    secure_qa: 'セキュリティの質問',
    staying: 'より速い購入のためにログイン状態を保持する',
    edit: '編集',
    browse_manage:
      'ログイン状態を維持するように選択された機器とブラウザを管理します。',
    account_type: 'アカウントの種類',
    account_delete: 'アカウント解約',
    business: 'ビジネス',
    edit_email: 'メールアドレスの編集',
    change_email: 'メールアドレスの変更',
    update_email: 'メールを追加',
    eamil_url: 'メールアドレス',
    update_email_url: 'メールアドレスの追加',
    error_email:
      '申し訳ありません。デフォルトの電子メールは、編集することができません。',
    confirm_new_email: '新しいメールアドレスの確認',
    change_mail: 'メール変更',
    confirm: '確認',
    changing: '変更',
    deleting: '削除',
    reaming:
      '現在の電子メールアドレスが2つのアカウントにリンクされています。 5つの電子メールを追加することができます。',
    qa_1: '初めて通った学校の名前は何ですか？',
    qa_2: '最初のペットの名前は何ですか？',
    edit_phone: '既存の電話番号を編集',
    korea: '大韓民国',
    explanation:
      '番号を追加することにより、本人はこの番号を追加する権限があり、プライバシーに記載された理由に基づいて自動的にダイヤルと事前録音電話や文字の受信に同意することを確認します。標準料金が適用されることがあります。',
    edit_phone_num: '電話番号の変更',
    edit_password: 'パスワードの変更',
    confirm_password: '現在のパスワードを確認',
    new_passod: '新しいパスワード',
    confirm_password_new: '新しいパスワードの確認',
    secure_question: 'セキュリティの質問',
    secure_pick: '質問を選択',
    secure_answer: '回答',
    edit_browse:
      '@:(brand.name) One Touchを利用すれば、毎回ログインすることなく、迅速に決済を完了することができます。',
    already_log: 'この機器にログインされた状態です。',
    off_all: 'すべての機器で@:(brand.name) One Touchオフ',
    support:
      'PayPalは、お客様の100％満足のために最善を尽くしています。アカウントに問題がある場合',
    support_center: 'サポートセンター',
    support_text1: 'に確認したり、',
    support_text2: 'にお問い合わせください。',
    support_warn:
      'アカウントを解約すると元に戻すことはできませんアカウントの記録と信頼性の数値も消えてしまいます。',
  },
  help: {
    support_center: 'サポートセンター',
    resolution_center: '紛争解決センター',
    qa_search: 'よくある質問検索',
    common_qa: '一般質問',
    common_qa_1:
      '`金額受ける`リンクを介して注文状況を更新した後、エラーメッセージが表示されるのはなぜですか？',
    common_qa_2:
      '韓国@:(brand.name)アカウントから資金を引き出すにはどうすればよいですか？',
    common_qa_3:
      '私@:(brand.name)アカウントにデビットカードやクレジットカードを追加するには、どうすればいいですか？',
    common_qa_4:
      'マイ@:(brand.name)アカウントのパスワードを忘れました。パスワードをリセットするには、どうすればいいですか？',
    common_qa_5:
      'すでに送信@:(brand.name)決済代金をキャンセルすることができますか？',
    common_qa_6: '@:(brand.name)を通じて支払いを受けるにはどうしますか？',
    common_qa_7:
      '@:(brand.name)を通じて決済代金を送信するにはどうすればいいですか？',
    common_qa_8:
      '@:(brand.name)アカウントに銀行口座を追加するには、どうすればいいですか？',
    common_qa_9:
      '私@:(brand.name)アカウントに接続された銀行口座を確認するには、どうすればいいですか？',
    common_qa_10:
      '@:(brand.name)アカウントの制限を解除するには、どうすればいいですか？',
    technical_support: '技術関連の問題と更新を購読してください。',
    muliple_help: '助けを受けるより、さまざまな方法',
    trading_help: '取引の問題などを解決する',
    tex_center: '税金センター',
    tex_help: '税務フォーム、およびその他のリソースの検索',
    need_help: 'お問い合わせ',
    help_center: 'サポートセンターへのお問い合わせ',
    help_to_center: 'サポートセンターへのお問い合わせ',
    prepare: '準備中です。',
    fast_help:
      '@:(brand.name)でより迅速に支援することができるように、お客様の問題を教えてください。',
    my_search: '私の問題を検索',
    common_problem: '一般的な問題',
    login_problem: 'ログインの問題',
    unkown_charge: '不正アクセスまたは知ら請求申告',
    send_money: '金額を送る',
    get_fund: '資金取得',
    withdraw_money: '金額引き出し',
    pay_cancel: '決済または注文のキャンセル',
    pay_hold: '決済保留または待機中',
    refund: '払い戻し',
    pre_pament: '事前承認支払い',
    negative_balance: 'マイナス残高',
    account_qa_1:
      'マイ@:(brand.name)アカウントから引き落とさ状態が「完了」と表示され資金が銀行口座に入っていないのはなぜですか？',
    account_qa_2:
      '私@:(brand.name)引き出しがまだ「待機中」の状態であるのはなぜですか？',
    account_qa_3: '私の引き出しが保留された理由は何ですか？',
    item_title: 'パスワードとアカウントへのアクセス',
    item_title_2: 'アカウントプロファイルと設定',
  },
  business: {
    no_trade: '両替可能なマーケットがありません。',
    view_your_account: '全口座照会',
    available: '使用可能',
    calculate_late: '最も重要なUSOT前口座の現在の資産を表示します。',
    payment_transfe: '決済代金振り込み',
    exchange: '両替',
    currency_update: '通貨を追加',
    update_btn: 'プラスボタン',
    currency_cal: '通貨の計算機',
    pay_default: '決済の設定',
    payment_send: '決済代金送信または要求',
    account_list: '口座リスト',
    no_alias: 'エイリアスなし',
    new_bank: '新しい銀行接続',
    card: 'カード',
    new_card: '新しいカードの接続',
    credit: 'クレジット',
    preference_payment: '好ましいオンライン決済手段を選択してください。',
    payment_tip:
      'オンラインでショッピングしたり、商品やサービスの決済代金を送信するときに、この手段を使用しています。決済時はいつでも、他の決済手段を選択することもできます。',
    payment_more: '決済の設定についてをご覧ください。',
    paymnet_changes: '@:(brand.name)残高',
    debit_card: 'デビットカード',
    currency_tip:
      '通貨を追加すると、その通貨で受け取る今後すべての支払いは、残高に入金されます。決済代金を送信したり、要求したとき、デフォルト通貨が使用されます。',
    currency_1: 'オーストラリアドル',
    currency_2: 'スイス・フラン',
    currency_3: 'チェココルナ',
    currency_4: 'デンマーククローネ',
    currency_5: 'ユーロ',
    currency_6: '英国ポンド',
    currency_7: '香港ドル',
    currency_8: 'フォリント',
    currency_9: 'イスラエル新シュケル',
    currency_10: 'メキシコペソ',
    currency_11: 'ノルウェークローネ',
    currency_12: 'ニュージーランドドル',
    currency_13: 'フィリピンペソ',
    currency_14: 'ポーランドズロチ',
    currency_15: 'ロシアのルーブル',
    currency_16: 'スウェーデンクローナ',
    currency_17: 'シンガポールドル',
    currency_18: 'バート',
    currency_19: '新台湾ドル',
    withdraw_account: '出金口座',
    exchanged: '両替後の通貨',
    exchange_rate: '為替レート',
    exchange_tip:
      'この為替レートは、現在の為替レートをベースにした推定金額であり、@:(brand.name)の両替手数料が含まれます。',
    currency_default: '日本円を基本通貨として設定します。',
    currency_default_notice:
      '決済代金を送信したり、要求したとき、デフォルト通貨が使用されます。',
    currency_default_notice2:
      'この通貨を閉じる他のお支払いをこの通貨でない限り残高に表示されません。',
    currency_default2: 'JPYを基に設定',
    currency_quit_jp_btn: '日本のドルを閉じる',
    currency_quit_btn: '通貨閉じる',
    bank_account: '口座',
    bank_account_create_day: '開設',
    bank_account_change: '残高',
    bank_account_check: '銀行確認',
    bank_account_remove: '銀行削除',
    bank_continue: '続きしますか？',
    bank_tip: 'この銀行を利用した大気中の取引は、削除された後も処理されます。',
    bank_this_delete: 'この銀行削除',
    card_tip:
      '@:(brand.name)アカウントを使うか引き出し限度なしに使用したいですか？',
    card_confirm: 'カードを確認してください。',
    card_type: 'タイプ',
    expiry_date: '有効期限',
    card_adress: '請求先住所',
    card_update: 'カードの更新',
    card_delete: 'カードの削除',
    card_this_delete: 'このカードの削除',
    card_tip2:
      '現在好ましい決済手段です。完了時に、他の好ましい決済手段を設定することができます。このundefinedを利用した大気中の取引は、削除された後も処理されます。',
    secure_code: 'セキュリティコード',
  },
  shop: {
    shop_list: 'お店リスト',
    shop_create: 'お店作り',
    shop_cre_date: '登録日',
    shop_title: 'お店名',
    shop_id: 'お店ID',
    shop_state: '状態',
    shop_work: '作業',
    shop_detail: '詳細',
    shop_retouch: '修正',
    shop_settlement: '精算口座リスト',
    shop_history: '取引の詳細',
    no_shop_list: '店のリストがありません',
  },
  merchant: {
    create: '店の登録',
    update: 'お店登録',
    retouch: '店の修正',
  },
  pay_legal: {
    service_usage: '@:(brand.name)サービス利用規約',
    detail_usage:
      'これらの利用規約は、アジア太平洋地域、一部のヨーロッパ、ラテンアメリカ諸国、中東、アフリカのユーザーに適用されます。他の国や地域の利用規約を表示するには、以下のリストから選択します。',
    nation: '国を選択',
    every_consumer: 'すべてのユーザー',
    service_agree: '@:(brand.name)サービスのためのユーザーの契約',
    privacy_state: 'プライバシーポリシー',
    purpose_policy: '@:(brand.name)利用目的の制限のポリシー',
    payment_agreement: '@:(brand.name)代替決済手段の契約',
    sell_buy: '売り手とのビジネス',
    shop_policy: '@:(brand.name)サポートモールポリシー',
    contract_profit: '営利法人の契約',
    billing_agreement: '請求契約',
    direct_debit_agreement: '@:(brand.name)資金を受信し、口座振替契約',
    additional_info: '追加情報',
    infringement: '侵害ソミョンソポリシー',
    policy_update: 'ポリシーの更新',
    warn1:
      '消費者に通知：@:(brand.name)決済サービスは、オーストラリアの法律に基づいて前払い手段（Stored Value Facility）とみなされます。',
    warn2:
      '@:(brand.name)前払い手段の所有者であるⓒ@:(brand.name)は、オーストラリア金融監督当局の承認を必要としません。消費者（ユーザー）は、これらの利用規約を注意深くお読みください。',
    warn3:
      'これらの利用規約と告知は、特定の@:(brand.name)サービスに関連する利用規約を提供しています。',
  },
  pay_privacy: {
    effective_day: '効力発生日：2019年3月28日',
    summary: '概要',
    personal_data: '@:(brand.name)で収集する個人データ',
    personal_date_cause: '@:(brand.name)で個人データを保持する理由',
    summary_1: 'は、ユーザーが当社',
    summary_2: 'サイト',
    summary_3: 'を訪問したり、',
    summary_4: 'サービス',
    summary_5: '利用時にユーザーの',
    summary_6: '個人データ',
    summary_7:
      'をどのように収集し、保管し、管理し、共有し、送信していることについて説明するために、本プライバシーポリシーを設けました。このプライバシーポリシーは、当社のサイトを訪問したり、サービスを利用する際、ユーザーの個人データに適用され、他の@:(brand.name)',
    summary_8: 'ユーザー',
    summary_9:
      'のウェブサイトやサービスを含む@:(brand.name)が所有または調整していないオンラインのウェブサイトやサービスには適用されません。',
    summary2_1:
      '@:(brand.name)は、ユーザーが当社のサイトを訪問したり、サービスを利用する際は、次のタイプの個人情報を収集することができます。',
    summary2_2: '登録と情報の使用',
    summary2_3:
      '@:(brand.name)のサービスを利用するためにアカウントを作成し登録すると、必要な情報を満たして、ユーザーが要求するサービスを提供するために、個人データを収集します。',
    summary2_4:
      '選択したサービスに応じて、ユーザーの名前、メールアドレス、電話番号、電子メールアドレス、アカウントを作成するために必要な識別情報などを提供してもらう要求することができます。',
    summary2_5:
      'ご利用のサービスに応じて追加の個人データを提供してもらう要求することができます。',
    summary3_1: '取引や経験について',
    summary3_2:
      '@:(brand.name)のサービスを利用したり、サイトに接続する場合は、例えば、販売から購入したり、金額を受領するか、請求を処理したり、友人や家族に金額をお送りいただく場合、@:(brand.name)で取引情報だけでなく、その他の取引関連情報を収集します。その他の取引関連情報は、送信したり、要求された量は、製品またはサービスに決済した金額、取引を完了するために使用されたすべての決済手段に関する情報を含む販売情報、機器情報、技術の使用データ、位置情報などが含まれます。',
    summary4_1: '参加者情報',
    summary4_2:
      '@:(brand.name)サービスを利用したり、サイトにアクセスすると、ユーザーが取引に関連するその他の参加者に提供する個人データを収集します。',
    summary4_3: '金額の送信または要求する',
    summary4_4:
      '@:(brand.name)サービスを通じて金額を送信したり、要求した場合、名前、メールアドレス、電話番号、ユーザからの金額を受けたり、ユーザーに金額を送る参加者の金融口座情報などの個人データを収集します。',
    summary4_5:
      '参加者に関連して、要求する個人データの範囲は、金額を送信したり、要求するために利用するサービスに応じて異なります。',
    summary5_1: '他の代わりの請求書を決済するか、他の人に告知書決済依頼する',
    summary5_2:
      '他の代わりの請求書を決済するか、他のユーザーに自分の代わりに請求書を決済してもらう要求するため@:(brand.name)サービスを使用する場合は、ユーザーから名前、住所、電話番号、電子メールアドレス、ユーザーが代わりに請求書を決済するか、他の人この代わりに、決済するようにしようとする口座番号を含むアカウントの所有者に関連する個人データを収集します。',
    summary6_1: 'アカウントに金額を追加する',
    summary6_1_1: 'ユーザーのアカウント',
    summary6_2:
      'ユーザーのアカウントまたはユーザーが所有することができる他のアカウントに資金を追加するために、または他のユーザーにこれらのアカウントに金額を追加してほしいと要請するために@:(brand.name)サービスを使用する場合は、要求を円滑に処理するために、ユーザーから相手の情報を収集したり、相手からユーザーに関する情報を収集することができます。',
    summary6_3:
      '例えば、携帯電話を充電したり、携帯電話の口座に金額を追加してほしいと要請するために@:(brand.name)サービスを使用する場合は、他の参加者からの個人データ、およびモバイル口座番号を含むその他の情報を収集することができます。',
    summary7_1: '友達と連絡先の人と関連した情報',
    summary7_2:
      'ユーザーが連絡先リストをアカウントに接続すると、お友達と連絡先の人との取引時@:(brand.name)での助けとなる、より容易にします。ユーザーが機器やソーシャルメディアのプラットフォーム間の接続を設定したり、@:(brand.name)アカウントを機器やソーシャルメディアプラットフォームと接続すると、@:(brand.name)から連絡先リストの情報（名前、住所、電子メールアドレスなど）を収集し、利用して、より良い@:(brand.name)サービスを利用できるように環境を改善します。',
    summary8_1:
      'ユーザーが追加のサービスまたは特定のオンラインサービスを利用するために@:(brand.name)に提供することに選択した情報',
    summary8_2:
      '選択的なサイトの機能を要求または参加したり改良されたサービスまたはその他の選択機能を要求する場合には、@:(brand.name)でユーザーの追加情報を収集することができます。',
    summary8_3:
      'このサービスで収集された情報の使用方法が、本プライバシーポリシーで明らかにした内容と異なる場合は、情報を収集する際告知します。',
    summary9_1:
      '「@:(brand.name)非会員決済」サービスを利用する場合は、ユーザーに関する情報',
    summary9_2:
      '一部の限られたサービスの場合は、ログインするか、非会員決済でアカウントの設定をしなければなら利用することができます。 @:(brand.name)は、ユーザーがトランザクションを完了するために必要な個人データは、すべての決済手段関連機器情報、技術の使用データ、位置情報を収集します。ユーザーがアカウントの所有者であり、非会員取引の決済を選択した場合、取引関連情報を収集して、ユーザーのアカウントと関連付けることができます。',
    summary9_3:
      'ユーザーがアカウントの所有者ではないながら@:(brand.name)非会員取引の決済を選択した場合、ユーザーが提供したすべての情報を収集し、保存して、その情報をこのプライバシーポリシーに基づいて使用して共有します。',
    summary10_1: '他社で取得ユーザーに関する情報',
    summary10_2:
      '売り手、データプロバイダ、クレジット調査機関のような第三者からの法律が許可する範囲内で情報を得ることができます。',
  },
  partner: {
    be_partner: '@:(brand.name)のパートナーになってみてください。',
    banner_text:
      'ショッピングモールのプラットフォームプロバイダ、マーケットプレイス、決済サービスを必要とする事業者を支援する決済代行業者が@:(brand.name)のパートナーになることがあります。',
    banner_btn: 'パートナー担当者に連絡する',
    benefit: '@:(brand.name)パートナーが受けることができる利点',
    benefit_1: 'ソリューションを構築するための統合と技術サポート',
    benefit_2:
      '@:(brand.name)統合の助けとなるためのサポートにいつでもお問い合わせください。 @:(brand.name)開発者ポータルもリソースとして活用することができます。',
    benefit_3: 'マーケティングの機会を通じたビジネスの成長',
    benefit_4:
      '@:(brand.name)が提供する様々なマーケティングの機会を活用して潜在的な顧客を引き付けることができます。',
    traction: '全世界の決済を牽引しています。',
    traction1:
      '@:(brand.name)パートナーは@:(brand.name)を信頼する販売者の円滑な決済のための革新的なプラットフォームをサポートしています。',
    traction_btn: 'より多くのパートナーを表示',
    program: '@:(brand.name)パートナープログラムに参加は無料です。',
    program_1:
      'オンラインフォームに記入していただければ@:(brand.name)で連絡をいたします。',
    program_2: '運営しているビジネスとソリューションについて説明してください。',
    program_3: '必要な事項を議論するために@:(brand.name)で連絡致します。',
    program_4:
      '@:(brand.name)と統合して、彼らは@:(brand.name)支払いを受けることができるよう支援します。',
    program_btn: 'パートナー担当者に連絡する',
    common_qa: 'よくある質問',
    common_qa1: 'いくつかのメーカーが@:(brand.name)パートナーにありますか？',
    common_qa1_text:
      '@:(brand.name)パートナーは、自社の顧客に@:(brand.name)ソリューションを提供するB2B（企業対企業）企業です。 @:(brand.name)はショッピングカート、ウェブホスティング会社は、Web開発者、物流業者、デジタルマーケティング代理店、決済ゲートウェイなどの組織と協力しています。',
    common_qa2: '@:(brand.name)パートナーサポート資格は何ですか？',
    common_qa2_text: 'パートナーの担当者にお問い合わせ',
    common_qa2_text_2:
      'とパートナーの資格要件について相談受けることができます。',
    common_qa3: '@:(brand.name)で統合サポートサービスを提供していますか？',
    common_qa3_text:
      '@:(brand.name)パートナープログラムに登録して、登録を承認受ける有用な統合関連文書および開発者フォーラムにアクセスすることができます。また、証明書の作成のための統合のコンサルタントの支援も受けることができます。',
    common_qa4:
      '韓国外でもビジネスを運営しているが、パートナープログラムに国別に登録しますか？',
    common_qa4_text:
      'ビジネスを運営している国によって異なります。 @:(brand.name)は地域のニーズに特化したパートナーの担当者を複数の国に配置しています。',
    common_qa4_more: 'パートナープログラムの提供国を見る',
  },
  pay_main: {
    total_product: '商品合計',
    total_sum: '量',
    pay_this_account: 'この口座を決済手段に設定します。',
    bill_show: 'この取引は、明細書には、次のように表示されます。',
    banner_text: '@:(brand.name)は、より安全で',
    banner_text2: 'クイック決済方法です。',
    banner_text3: 'どこで買い物をしても、金融情報を安全に守ります。',
    footer_1: '規約',
    footer_2: 'ユーザー契約',
    footer_3: 'プライバシーポリシー',
    footer_4: 'フィードバック',
    footer_5:
      '消費者に通知：@:(brand.name)前払い手段の所有者であるⓒ@:(brand.name)は、オーストラリア金融監督当局の承認を必要としません。',
    footer_6: '利用規約',
    footer_7: 'を注意深くお読みください。',
    footer_8: '決済',
    wallet: '電子財布管理',
    last_name: '性',
    card_number: 'カード番号',
    three_number: '3桁の',
    name: '名前',
    pay_brand: '@:(brand.name)で支払い',
    free_shipping:
      '@:(brand.name)アカウントがあれば、無料返品送料、購入保護などを受けることができます。',
    email_phone: '電子メールまたは携帯電話番号',
    login_error: 'ログインに問題がありますか？',
    pay_card: 'カードで決済',
    cancel_back: 'キャンセルして前のページに戻る',
  },
  site_map: {
    site_map_tip: '@:(brand.name)アカウントを見回すと、役立つリンクです。',
    map_fund: '資金',
    map_fund_1: '金額振替',
    map_fund_2: '私の使用機能のバランスとは？',
    map_fund_3: '金額の送信または要求',
    map_fund_4: '通話管理',
    map_fund_5: '私@:(brand.name)デビットカード割引',
    map_fund_6: '@:(brand.name)デビットカード取得',
    map_fund_7: '@:(brand.name) Credit決済スケジュールの設定',
    map_deal: '取引',
    map_deal_1: 'すべての取引活動の履歴を表示',
    map_deal_2: '活動履歴の表示（残高と手数料を含む）',
    map_deal_3: '取引グラフとチャートを表示',
    map_deal_4: '取引ダウンロード',
    map_deal_5: 'クレームやチャージバックに応答',
    map_deal_6: 'IPN（即時決済通知）の履歴',
    map_profile: '私のプロフィールと設定',
    map_profile_1: 'ビジネス情報ミョンギョン',
    map_profile_2: '電子メール、住所、電話またはパスワードの更新',
    map_profile_3: '銀行口座やカードの更新',
    map_profile_4: '通知の更新',
    map_profile_5: 'アカウントの制限を表示',
    map_profile_6: 'ユーザーの管理',
    map_profile_7: '配送設定の更新',
    map_support: 'サポート',
    map_support_1: '紛争解決センターに移動',
    map_support_2: 'サポートセンターに移動',
    map_support_3: 'お問い合わせ',
    map_support_4: '@:(brand.name)販売手数料について',
    map_report: 'レポート',
    map_report_1: 'レポートの設定、管理、またはダウンロード',
    map_manage: 'ツール',
    map_manage_1: '私のツールを表示',
    map_manage_2: '@:(brand.name)ボタン管理',
    map_manage_3: '定期支払いの管理',
    map_consum: 'お客様',
    map_consum_1: '顧客リストを表示',
  },
  fee: {
    fee_tip: 'シンプルな料金体系',
    fee_banner_1:
      '一般的に、購入は無料で両替手数料が適用される場合があります。',
    fee_banner_2:
      '@:(brand.name)を利用して販売する月の手数料やキャンセル料が付きません。各販売後の手数料のみ支給します。',
    fee_h2: '一般的に、購入は無料です。',
    fee_text1: '決済処理のための手数料は、売り手が支払います。',
    fee_text2: 'ただし、両替手数料が適用される場合があります。',
    fee_more: '販売手数料さらに詳しく',
    fee_text3:
      'ウェブサイトからの請求書やメール決済を利用して販売します。（海外決済標準料率を適用）',
    fee_text4: '受領した通貨に基づいた固定料金',
    fee_text5: '両替手数料が追加で適用されることができます。',
    fee_text6: 'たとえばUSDで受領された決済金額の固定料金は$ 0.30 USDです。',
  },
  dash: {
    more: 'もっと見る',
    withdraw_asset: '資金引き出し',
    currency: '通貨',
    quotes: '請求書や見積',
    last_6_months: '最近6ヶ月',
    make_invoice: '請求書の作成',
    manage_invoice: '請求書の管理',
    grown_up: '見積もりを送って、ビジネスを成長させるましょう。',
    un_paid_invocie: '未払いの請求書',
    make_quotes: '見積作成',
    quotes_1: '1件の未払いの請求書があります。',
    quotes_2: '@:(brand.name)請求',
    quotes_alarm: '事前通知の送信',
    quotes_detail: '詳細表示',
    quotes_who: '請求対象：チェ・ソヨン',
    latest_act: '最近の活動内容',
    act: '活動',
    received: '受信した決済代金',
    send: '送信決済代金',
    act_record: '活動内容（残高および手数料を含む）',
    pay_person: '請求者名',
    show_all: 'すべて表示',
    tell_us: '意見を教えてください。',
    feed_text:
      'しばらく時間を割いて、このページの再設計された情報を表示するにコメントを教えてください。ありがとうございます！',
    service: 'フィードバックを提供',
    feed_text_back:
      '意見をいただきありがとうございます！私たちのサイトがどのように役立つましたか？',
    feed_placeholder:
      '今日@:(brand.name)に来た理由を教えていただければ、より良い方法があります。電子メールまたはアカウント番号などの個人情報が含まれていません。',
    feed_p:
      '@:(brand.name)従業員とオフィスのお客様が見ることができるようにあなたの意見が内部的に発行されることがありますので、個人情報を残さないでください。顧客サービスの問題は、こちらをクリックしてください。 @:(brand.name)の',
    feed_protect: '個人情報保護方針',
    feed_law: '法的条件',
    feed_or: 'と',
    feed_need: 'を参照してください',
    trade_name: '取引名',
    trade_id: '取引ID',
    transaction_type: '取引タイプ',
    trade_amount: '決済金額',
    detail_show: '表示',
  },
  shop_detail: {
    detail_info: '店の詳細',
    api_signature: '店署名キー',
    msg_shop_create: '店が登録されました。',
    msg_shop_modify: '店が修正されました。',
  },
  merchant_account: {
    create_account: '精算口座作成',
    enroll_account: '精算口座登録',
    pls_select_account: '精算口座を選択してください',
  },
  transaction_detail: {
    transaction_title: '取引の詳細',
    order_id: '店舗注文番号',
    pay_account_title: '支払い口座名',
    pay_account_number: '支払い口座番号',
    pay_account_balance: '支払い口座残高',
    pay_account_selection: '支払い口座選択',
    pay_account_selection_msg: '支払い口座を選択してください。',
  },
  guide: {
    guide_title_1: '@:(brand.name)口座',
    guide_title_2: '@:(brand.name)の変形と送金はどのように違うのですか？',
    guide_title_3:
      '@:(brand.name)の口座を介して、より便利で安全なサービスを利用してみてください',
    guide_strapline_1: '①手数料なしですぐ送金が可能な口座',
    guide_strapline_2: '②簡単な方法で迅速口座開設可能',
    guide_strapline_3: '変形',
    guide_strapline_4: '送金',
    guide_strapline_5: '国内で最も多くの種類のコインを預けできる口座',
    guide_strapline_6: 'ハッキングから安全口座',
    guide_strapline_7: '変形の履歴照会および領収書の発行が可能',
    guide_strapline_8: '企業精算口座に使用可能',
    guide_strapline_9: 'C2CとB2C取引時口座を通じて迅速取引が可能',
    guide_strapline_msg_1: '@:(brand.name)の口座間送金は手数料が発生しません。',
    guide_strapline_msg_3: '@:(brand.name)の口座開設は、10秒で可能です。',
    guide_strapline_msg_4: '複雑なプロセスは省略しました。',
    guide_strapline_msg_5: '当該資産の口座名を入力すると、すぐに作成できます。',
    guide_strapline_msg_6: '財布を通じた送金',
    guide_strapline_msg_7: '財布アドレス利用',
    guide_strapline_msg_8: '手数料賦課',
    guide_strapline_msg_9: '@:(brand.name)内での送金',
    guide_strapline_msg_10: '口座番号利用',
    guide_strapline_msg_11: '手数料Zero',
    guide_strapline_msg_12:
      '多くの種類のパスワード貨幣が世界中で発行されています。@:(brand.name)は、これらの変化に合わせて、お客様の利便性を支援するために、さまざまな パスワードの通貨を取り扱っています。',
    guide_strapline_msg_13:
      'セキュリティは、パスワードの通貨の中核です。@:(brand.name)は、セキュリティを最も重要だと考えて、それぞれの分野で5年以上のキャリアを持つデジタルエンジニアがセキュリティシステムを構築しました。',
    guide_strapline_msg_14:
      '口座間送金履歴を照会することができます。@:(brand.name)の口座は市中銀行のようにバンク間または他の財布口座振替の履歴を確認することができます 。必要に応じてポイントを訪問し、発行履歴を確認し、出力することができてもできます。',
    guide_strapline_msg_15:
      '@:(brand.name)の口座は@:(brand.group)マーケットの支払いと精算口座と連動します。対象パスワード貨幣口座を精算口座に登録した後、@:(brand.group)マーケットで販売され た物品の代金を暗号通貨での精算が可能です。',
    guide_strapline_msg_16:
      '財布を通じた対人の取引には手数料と遅延が発生します。@:(brand.name)はこれを解決する方法として、@:(brand.name)口座振込を提案します。@:(brand.name)の 口座を介して手数料と遅延がないC2CとB2C取引を体験してください。',
  },
  account_transfer: {
    transfer: '口座振替',
    transfer_list: '振り込み内訳詳細',
    transfer_list_title: '@:(brand.name)口座振込',
    transfer_list_wallet: '外部へ送金',
    msg_required_data: '値をすべて入力してください',
    msg_not_select_withdraw_account: '出金口座を選択してください',
    create_transfer_title: '口座振替',
    from_account_select: '出金口座を選択',
    available_transfer: '変形可能金額',
    to_account_input: '振替口座番号を入力',
    to_account_confirm: '振り込み口座確認',
    to_account_user_name: '振替口座の会員名',
    transfer_amount: '送金金額',
    delete_amount: '訂正',
    all_amount: '全額',
    description: '説明',
    transfer_btn: '振り込み',
    transfer_info_check: '変形申請情報を確認',
    from_account_number: '出金口座番号',
    from_asset_title: '出金口座の資産',
    to_account_number: '振替口座番号',
    success_transfer: '変形が正常に処理されました。',
    transfer_list_detail: '振込内訳照会',
    search_transfer_asset: '資産別検索',
    search_transfer_account: '口座別検索',
    reset: '初期化',
    search: '検索',
    transfer_list_detail_tit: '振り込み内訳詳細',
    no_transfer: '変形の履歴なし',
    msg_not_search_account: '存在しない口座番号または無効入力値です。',
    my_account_transfer: '本人口座振替',
    msg_pls_select_account: '資産を選択した後、口座を検索してください。',
    placeholder_amount: '振替金額を入力してください',
    not_search_user_name: 'ユーザ名を確認できません',
    msg_select_asset_search: '口座を選択してください。',
    success_fail: '変形が失敗しました。',
    pls_search_asset: '資産を検索してください。',
    pls_search_account: '口座を検索してください。',
    pls_select_asset: '資産を選択してください。',
    not_exist_account: '当該資産の口座が存在しません。',
    no_inquiry_history: '照会内容がありません。',
    account_number_list_1: '6月前デビットは照会できません。',
    account_number_list_2: '最大ビュー数は6ヶ月です。',
    account_number_list_3:
      '現在の転送結果を提示することは、照会とマーチャント転送の結果を@:(brand.name)に照会するページです。<br />他 の財布との転送の結果を表示したい場合は、上部の[財布転送]の上を確認してください。',
    account_number_list_3_1:
      '県変形の結果照会は@:(brand.name)内の照会および加盟店の変形の結果を照会するページです。 <br/> @:(brand.name)口座に送金結果を照会したい方は、上部に[@:(brand.name)口座振替]で確認してください',
    today: '日',
    one_week: '1週間',
    one_month: '1ヶ月',
    three_months: '3ヶ月',
    six_months: '6ヶ月',
    withdrawal_account_number: '出金口座番号',
    recent_order: '最近順',
    past_order: '過去の順序',
  },
  bank_service_center: {
    title: 'タイトル',
    date: '日',
    state: '状態',
    enter_search_word: '検索用語を入力してください',
    list: 'リスト',
  },
  service_center: {
    view_all: '一覧',
    contact_history: 'お問い合わせ内訳',
    privacy_Statement: 'プライバシーポリシー',
    would_you_agree: '上記の内容に同意しますか？',
    mobile_number: '携帯電話番号',
    target_of_inquiry: 'お問い合わせタイトル',
    inquiry_contents: 'お問い合わせの内容',
    please_enter_your_inquiry: 'お問い合わせ内容を入力してください。',
    send: '送信',
    normal_inquiries_received:
      'お問い合わせいただいた内容が正常に受付完了しました。',
    inquiry_history: 'お問い合わせ内容に',
    pls_select_inquiry_type: 'お問い合わせの種類を選択してください',
    pls_login_to_use_inquiry:
      '1：1お問い合わせを利用するには、ログインしてください。',
    non_member_login: '非会員ログイン',
    contact_id: 'お問い合わせのID',
    view_inquiry: 'お問い合わせ表示',
    service_center: '顧客センター',
    inquiry_details: 'お問い合わせ詳細',
    msg_enter_title: 'タイトルを入力してください。',
    msg_enter_your_content: '内容を入力してください。',
    msg_pls_login: 'ログインしてください。',
    go_back: '戻る',
    re_contact: '再問い合わせ',
    contents: '内容',
    msg_no_inquiry_history: 'お問い合わせ内容がありません。',
    msg_require_login_additional_authentication:
      'ログインまたは追加の認証が必要です。',
    when_you_member: '会員であるとき',
    msg_inquiry_history_can_view_after_login:
      '会員のお問い合わせ内訳はログイン後閲覧可能です。',
    non_member: '非会員であるとき',
    lookup_inquiry: 'お問い合わせ照会',
    msg_enter_inquiry_id: 'お問い合わせIDを入力してください。',
    msg_enter_password_when_registering_your_inquiry:
      'お問い合わせ登録時に設定したパスワードを入力してください。',
    frequently_asked_questions: 'よくある質問',
    msg_enter_your_password: 'パスワードを入力してください。',
    pls_search_fap: '質問を検索してください。',
    msg_source_filename_none: '添付された写真がありません。',
    super_inquiry: '上位問い合わせ',
  },
  modal: {
    not_seeing_day: '日中見ない',
  },
  login_guide_modal: {
    title: '案内事項',
    sub_title:
      '会員たちの円滑な取引所利用のために、ログインシステムが改編される予定です。',
    content:
      '【変更前】<br/>最初に登録時に作成IDログイン<br/><br/> [変更後] <br/>使用されている電話番号やメールアドレスログインに変更<br/> <br/>ログインシステムが改変されるまでログイン方法は、最初加入の際に作成してくださったIDでログインしていただければされます。',
  },
  affiliate: {
    affiliate_occur_list: '手当発生内訳',
    affiliate_adjust_list: '手当精算内訳',
    allowance_balance_asset: '資産別手当残高',
    list_allowance_balance_asset: '資産別手当残高リスト',
    search_by_asset: '資産別検索',
    allowance_search: '手当対象検索',
    generator: '発生者',
    beneficiary: '受益者',
    benefactor: '恩恵者',
    behavior_type: '行動タイプ',
    target_unique_number: '対象固有の番号',
    date_of_occurrence: '発生日',
    application_policy_name: '適用ポリシー名',
    beneficiary_type: '受益者のタイプ',
    benefactor_type: '恩恵者タイプ',
    target_amount: 'ウォン金額対象',
    principal_amount: 'ウォン金額',
    allowance: '手当',
    allowance_assets: '手当資産',
    allowance_amount: '手当額',
    affiliate_log: '手当の内訳',
    allowance_settlement: '手当精算',
    allowance_settlement_info: '手当精算情報',
    name_asset_settled: '手当精算される資産人',
    balance_receive_payment: '手当精算される残高',
    select_account_settled: '精算される口座の選択',
    no_affiliate_log: '手当発生内訳はありません。',
    no_affiliate_balance: '資産別手当残高一覧がありません。',
    no_affiliate_adjust: '手当精算内訳がありません。',
    asset_name: '資産人',
    asset_code: '資産コード',
    balance: '残高',
    cumulative_amount: '累積金額',
    please_select_account: '口座を選択してください。',
    calculate: '精算',
    settle: '精算する',
    calculate_amount: '精算金額',
    account_number: '口座番号',
    registration_date: '登録日',
    number: '番号',
  },
  coin_name: 'コイン名',
  main_function: '主な機能',
  disclosure_ing: '過程において',
  quick_service: 'クイックサービス',
  new_account: '口座開設',
  social_login: 'ソーシャル',
  way_to_find: 'アクセス情報',
  korea_head_office: '@:(brand.name)韓国本店',
  branch_office: '@:(brand.name) KOREA 新沙店',
  address_head_office: 'ソウル江南区彦州路528',
  address_branch_office: 'ソウル市江南区ノンヒョン路803',
  map: '地図を描く',
  korean_language_counseling: '韓国語相談',
  hours_of_business: '韓国時間基準10時～19時(土,日国家指定休日は除く)',
  overseas_consultation: '海外協議',
  email_consultation: 'メール相談',

  exchange_price: '両替/相場',
  market_price_check: '相場照会',
  full_account_inquiry: '全口座照会',
  exchange_details_check: '両替内訳照会',
  cryptocurrency_exchange_history: '両替内訳',
  deposit_account_inquiry: '資金預置口座照会',
  transfer_result_check: '振り込み結果照会',
  dormant_account_check: '休止アカウントの確認',
  account_and_other_case_status:
    '@:(brand.name)アカウントとその他のケースのステータスを確認する',
  account_and_other_wallet: '@:(brand.name)口座及び他財布照会',
  account_search: '@:(brand.name)口座照会',
  other_wallet_search: '他の財布振込',
  error_remittance: '@:(brand.name)で送金エラーを返却することに同意',
  transfer: '振り込み',
  other_wallets_transfer: '他のウォレット/転送結果を確認する',
  other_wallets_transfer_search: '外部送金結果照会',
  frequently_used_accounts: 'よく使うアカウントの登録・管理',
  new_demand_account: '要求払口座新規',
  new_installment_savings_account: '新しい分割払い普通預金口座',
  new_deposit_account: '新しい定期預金口座',
  check_account_progress_account:
    'アカウントの新しいアカウント進行状況を確認する',
  download: 'ダウンロード',
  withdrawal: '出金',
  Smart_window_withdrawal: 'スマートウィンドウの引き出し',
  smart_ATM_withdrawal: 'スマートATMの引き出し',
  customer_service: '顧客サービス',
  notice: 'お知らせ',
  one_one_inquiry: '1：1お問い合わせ',
  inquiry_details: 'お問い合わせ内容',
  frequently_asked_questions: 'よくある質問',
  server_notice: 'サーバー通知',

  service_hours: '顧客満足サービス運営時間',
  all_day_long: '（24時間お問い合わせが可能)',
  online_service_hours: 'オンライン@:(brand.name)利用時間',
  unusable_hours: '24時 年中無休 (23:30 - 24:00 利用不可)',
  offline_hours: 'オフライン銀行利用時間',
  offline_bank_hours: '(土日祝日を除く)',

  management: '管理',
  secure_management: '安全な認証/管理',
  fund_limit_management: '資金制限管理',
  issue_details_check: '問題の詳細チェック',
  part_of_news: 'これはニュースの一部です。',
  part_of_notice: 'これは発表の一部です',
  full_menu: 'フルメニュー',
  individual: '個人',
  key_coin: 'パスワードの通貨を実際の通貨に接続する@:(brand.name)の基軸コイン',
  limitation_info: '電気通信金融詐欺被害予防をための限度制限案内',
  limitation_info_1:
    '要求払口座が非対面で開設され自動化機器、インターネットを通じた引き出し(振り込み)限度は１日{０}USOTに制限されます。',
  limitation_info_2:
    '取引目的が確認できる客観的な認証資料を支店に提示するか「管理→セキュリティ認証/管理」で限度制限が解除できます。',
  limitation_info_3:
    'インターネットバンキングサービスを利用する時、出金口座に登録してから振り込み取引ができます。',
  limitation_info_4: '暗号通貨別限度制限口座は一人５個まで開設できます。',
  limitation_notice: '注意事項',
  limitation_notice_1:
    'インターネットバンキング加入は入出金口座を開設した後、完了画面で連動して申請することができます。',
  limitation_notice_2:
    '既存のインターネットバンキング加入顧客は出金口座登録区分がインターネット＋支店になっている場合にのみ、インターネットバンキングで出金口座登録を行うことができていることに注意してください。',
  limitation_notice_3:
    '＊インターネットバンキングで振り込み取引をより簡単に進むためにはセキュリティ認証をする必要があります。認証過程を通じて等級を向上させてから口座開設及び出勤口座登録を行ってください。',

  new_subscription: '新規加入',
  new_subscription1_1: '新規加入ボタンをクリックすると、会員固有の',
  new_subscription1_2:
    '@:(brand.name)専用口座と外部財布連動入金アドレスが発行されます。',
  new_subscription2_1:
    '入金前に必ず知っておいてください！@:(brand.name)専用口座から@:(brand.name)の専用口座に送金すると手数料は一切ありません。新規加入時に発行される口座/アドレスには ',
  new_subscription2_2:
    'のみ入金が可能です。該当アドレスに他のデジタル資産を入金しようとするときに発生するエラー/損失は回復不可能です。1回の確認が行われた後、入金プロセスを経て、残高に反映されます。入金プロセスは自動的に行われ、ネットワークの状況に応じて所要時間が異なる場合があります。上記アドレスは、入金専用アドレスです。',
  new_subscription3_1: '会員に割り当てられた新規加入では',
  new_subscription3_2: 'を入金することができます。',
  new_subscription4: '上記事項に同意と理解しましたか',

  created_account_number: '生成された口座番号',
  exclusive_account: '@:(brand.name)専用口座番号',
  depositing_external_wallet: '外部財布から@:(brand.name)入金',
  use: '使用する',
  we_future: '私たちの未来',
  pop_brand: '@:(brand.name)',
  fourth_industry: '第4業界のリーダー',
  oc_15: '10月15日',
  officially_open: '正式オープン！',
  head_branch_office: '韓国本店（蚕室支店）/第一支店（新沙支店）',
  sep_15: '9月15日午後5時',
  open_popup: 'オープン',
  thanks_for: '声援に感謝いたします。',

  direct_exchange: {
    sell_buy_assets: '販売および購入資産',
    replace_assets: '交換する資産',
    ccm_exchange_rate: 'CCM保有優遇適用為替レート',
    buy_sell_percent: '購入-10％販売+ 10',
    expected_property: '予想財産',
    preferential_property: '優遇された資産',
  },

  event_banner: {
    month_hotcoupon: '今月の HOTクーポン を確認してください。',
    hotcoupon_sub: '為替レートから各種アフィリエイトクーポンまで！',
    grab_bug: 'バグをキャッチ',
    grab_bug_sub:
      '1：1お問い合わせを残してください。抽選で商品を差し上げます。',
    event2_sub_title: '生涯初',
    event2_title: '<span style="font-weight: 700">CCM</span>配当',
    event2_text:
      '<span style="font-weight: 700">加入する</span>だけで<span  style="font-weight: 700">配当金</span>がどんどんもらえる<span  style="font-weight: 700">ファンド？</span><br><span style="font-weight: 700">グレードUP</span>するだけで<br><span style="font-weight: 700">手数料</span>は<span style="font-weight: 700">DOWN</span><br><span style="font-weight: 700">配当金</span>が湧き出る<span style="font-weight: 700">商品</span><br><span style="font-weight: 700">CCM</span>との<span style="font-weight: 700">初出会い！</span>',
    // '<span style="font-weight: 700">加入</span>だけで<span style="font-weight: 700">配当金</span>をどんどんあげる<span style="font-weight: 700">ファンド</span>？<br><span style="font-weight: 700">グレードUP</span>するだけで<br><span style="font-weight: 700">手数料</span>は<span style="font-weight: 700">DOWN</span><br><span style="font-weight: 700">配当金</span>が湧き出る<span style="font-weight: 700">商品</span><br><span style="font-weight: 700">CCM</span>との<span style="font-weight: 700">初出会い！</span>',
    event2_btn: '加入する',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: '閉じる',
    notice_today: '今日一日見ない',
  },
}
